<template>
  <div>
    <!-- Wrap Space in a container to handle the fade-out -->
    <div
      v-if="isSpaceVisible"
      :class="{ 'fade-out': isFadingOut }"
      class="space-container"
    >
      <Space />
    </div>

    <!-- Dynamically styled header -->
    <div :class="['header']" class="pa-0">
      <Header :updateCurrentSection="updateCurrentSection" />
    </div>

    <!-- Main sections -->
    <div id="star-container">
      <div id="star-pattern"></div>
      <div id="star-gradient-overlay"></div>
    
      <!-- Move your sections inside the star container -->
      <div
        v-for="(section, index) in sections" 
        :key="index"
        :class="['home', { active: currentSection === index }]"
      >
        <component :is="section" />
      </div>
    </div>
  </div>
</template>

<script>
import Space from "./Space-IN.vue";
import Header from "./Header.vue";

// Import your section views
import About from "./sections/About.vue";
import Skills from "./sections/Skills.vue";
import Work from "./sections/Work.vue";
import Projects from "./sections/Projects.vue";
import Contact from "./sections/Contact.vue";
// import Resume from "./sections/Resume.vue";

export default {
  name: "Home",
  components: {
    Space,
    Header,
  },
  data() {
    return {
      isSpaceVisible: true, // Controls whether the Space is visible
      isFadingOut: false, // Controls whether the fade-out animation is active
      sections: [About, Skills, Work, Projects, Contact], // Section components imported from other files
      currentSection: 0, // The index of the currently visible section
      isScrolling: false, // To prevent rapid scrolling
    };
  },
  mounted() {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    
    window.addEventListener("wheel", (event) => {
      event.preventDefault(); // Blocks default scrolling
    }, { passive: false }); // Allows `preventDefault()`
    
    // Start the fade-out process after 3 seconds
    setTimeout(() => {
      this.isFadingOut = true; // Activate the fade-out class
      setTimeout(() => {
        this.isSpaceVisible = false; // Remove the Space component from the DOM after fade-out
      }, 1000); // Wait for the duration of the fade-out animation
    }, 3000); // Delay before starting the fade-out

    // Add scroll event listener
    window.addEventListener("wheel", this.handleScroll);
  },
  beforeUnmount() {
    // Clean up scroll event listener
    window.removeEventListener("wheel", this.handleScroll);
  },
  methods: {
    handleScroll(event) {
      const scrollZone = event.target.closest('.scroll-on-hover');
      if (scrollZone) {
        return;
      }

      if (this.isScrolling) return;

      this.isScrolling = true;

      if (event.deltaY > 0) {
        this.nextSection();
      } else {
        this.prevSection();
      }

      setTimeout(() => {
        this.isScrolling = false;
      }, 800);
    },
    nextSection() {
      if (this.currentSection < this.sections.length - 1) {
        this.currentSection++;
      }
    },
    prevSection() {
      if (this.currentSection > 0) {
        this.currentSection--;
      }
    },
    updateCurrentSection(index) {
      this.currentSection = index; // Update the active section index
    },
  },
};
</script>

<style scoped>
#app {
  margin: 0;
  padding: 0;
}

html, body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Space container */
.space-container {
  background-color: black; /* Initial background color */
  transition: opacity 1s ease, background-color 1s ease 1s; /* Smooth fade-out transition */
  position: fixed; /* Ensure it covers the entire screen */
  top: 0;
  left: 0;
  width: 100vw; /* Full screen width */
  height: 100vh; /* Full screen height */
  z-index: 9999; /* Place it above all other elements */
}

/* Fade-out effect */
.fade-out {
  opacity: 0; /* Fully transparent */
  background-color: transparent; /* Background transitions to transparent */
}

/* Header */
.header {
  position: fixed; /* Keep the header fixed at the top */
  top: 0;
  left: 0;
  width: 100vw; /* Full width */
  height: 8.5vh; /* 8.5% of the viewport height */
  z-index: 2000; /* Ensure header is above the sections but below the space-container */
  background-color: #133a5e; /* Match header background to avoid overlap issues */
  padding: 10px 20px; /* Add spacing for visual clarity */
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3); /* Add slight shadow for better visibility */
}

/* Sections */
.home {
  width: 100vw;
  height: 91.5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  opacity: 0; /* Initially invisible */
  pointer-events: none; /* Prevent interaction when not active */
  transition: opacity 0.8s ease, pointer-events 0.8s ease; /* Smooth transition */
  position: fixed; /* Keeps sections locked inside viewport */
  top: 8.5vh;
  left: 0;
}

/* Ensure the currently active section is visible */
.home.active {
  z-index: 1001; /* Lower than star-pattern */
  opacity: 1; /* Keep visibility */
  pointer-events: auto; /* Enable interaction */
  position: relative;
  box-sizing: border-box;
}

html, body {
  overflow: hidden !important;
  height: 100vh;
  max-height: 100vh; /* Prevents extra scroll space */
}





:root {
  --glow-rgb: 245 245 245;
  
  --light-gold-rgb: 249 181 51;
  --dark-gold-rgb: 215 147 23;
  
  --primary-stripe-rgb: 230 230 230;
  --secondary-stripe-rgb: 240 240 240;
}

body {
  background-color: black;
  cursor: none;
  overflow: hidden;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

@keyframes pan {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 100% 0%;
  }
}

#app {
  height: 100vh;
  overflow: hidden;
  position: relative;
}

#star-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 900; /* Ensures visibility */
}

#star-pattern {
  background-image: url('@/assets/star-pattern.png');
  background-size: 10%;  
  position: absolute;
  left: 50%;
  top: 0px;
  translate: -50% 0%;
  z-index: 901;
  height: 100%;
  width: 100%;
  min-width: 1200px;
  opacity: 0.40;
  animation: pan 180s linear infinite;
  will-change: background-position;
  background-repeat: repeat; /* Makes the pattern repeat */
}

#star-gradient-overlay {
  background: radial-gradient(ellipse at center, #f4e09c, #ddaf52);
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.9;
  z-index: 900;
}

</style>